import {WdiTable} from '@/components/WdiControls/WdiTable';
import {WdiModal} from '@/components/WdiControls/WdiModalForm';
import {WdiModalProps} from '@/components/WdiControls';

type CodeOrNameTableProps = {
  onClose?: () => void;
} & WdiModalProps;
export const CodeOrNameTableApp: React.FC<CodeOrNameTableProps> = (props) => {
  const {title, data} = props;
  const columns = [
    {
      title: title,
      dataIndex: 'codeOrName',
      width: 130,
      ellipsis: true,
      render: (value: any, record: any) => {
        return record.codeOrName;
      },
    },
  ];

  return (
    <>
      {data && data.length > 0 && (
        <WdiModal
          width={500}
          visible={props.visible}
          onCancel={() => {
            props.onClose ? props.onClose() : null;
          }}
          title={title}
          footer={null}
        >
          <WdiTable columns={columns} dataSource={data} pagination={false} allowFilterColumn={true}/>
        </WdiModal>
      )}
    </>
  );
};
